// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compact-work-item.history-work-item .writers {
  flex: 0 1 40%;
}
.compact-work-item.history-work-item .shares-group {
  flex: 0 0 15rem;
}
.compact-work-item.history-work-item .song-code {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/WorkItemV2/History/HistoryCompactWorkItem/index.scss"],"names":[],"mappings":"AAEI;EACE,aAAA;AADN;AAII;EACE,eAAA;AAFN;AAKI;EACE,aAAA;AAHN","sourcesContent":[".compact-work-item {\n  &.history-work-item {\n    .writers {\n      flex: 0 1 40%;\n    }\n\n    .shares-group {\n      flex: 0 0 15rem;\n    }\n\n    .song-code {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
